module.exports = __webpack_public_path__ + "img/1557614060995944450.bd45ec54.png";